<h2>Open Externally</h2>
You can now open 
<div><a style="white-space: nowrap" href="{{ data.url }}">{{ data.url }}</a> </div>
in {{ data.action.client.extern.app }}.
For information on opening externally please read <a href="{{ data.action.client.extern.info }}">This</a>
<div fxLayout="row" fxLayoutAlign="space-between stretch" style="width: 100%">
<button mat-button (click)="close(null)">OK</button>
</div>